import React, { useCallback, useState } from 'react';
import { Popover } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ArrowDownIcon } from '../../../../resources/assets/DLS_ArrowDown.svg';
function OverflownModulesPopover(props) {
    const { currentModule, modules, moreDropdownExpression } = props;
    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const onPopoverModuleClick = useCallback((module) => {
        props.onModuleClick(module);
        setPopoverOpen(false);
    }, []);
    if (!modules.length) {
        return null;
    }
    const dropdownButtonClassName = classNames({
        'c-application-bar__overflow-modules-button': true,
        'c-application-bar__overflow-modules-button--active': isPopoverOpen,
    });
    return (React.createElement(Popover, { className: "c-application-bar__overflow-modules", onClose: () => setPopoverOpen(false), open: isPopoverOpen, showArrow: true },
        React.createElement("div", { className: dropdownButtonClassName, onClick: () => setPopoverOpen(true) },
            MessageService.translate(moreDropdownExpression),
            React.createElement(ArrowDownIcon, null)),
        React.createElement(Popover.Content, null,
            React.createElement("div", { className: "c-application-bar__overflow-modules-content" }, modules.map((module) => {
                const className = classNames({
                    'c-application-bar__overflow-module': true,
                    'c-application-bar__overflow-module--active': module.id === currentModule?.id,
                });
                return (React.createElement("span", { className: className, key: module.id, onClick: () => onPopoverModuleClick(module) }, MessageService.translate(module.name)));
            })))));
}
export { OverflownModulesPopover, };
//# sourceMappingURL=overflown-modules-popover.js.map